/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2020, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */

export const appConstants = {
  noop: () => {
    return;
  },
  desktopIntegrations: 'desktopIntegrations',
  externalApp: 'externalApp',
  uvip: 'uvip',
  messageId: 'messageId',
  username: 'username',
  STAT_CODE_AUTO_ADVANCE: 5,
  YES: 'YES',
  NO: 'NO',
  CANCEL: 'CANCEL',
  SHOW_IMAGES: 'SHOW_IMAGES',
  DATE_SEPARATOR: '-',
  TIME_SEPARATOR: ':',
  SPACE: ' ',
  RA1000_APPROVER_ADDED: 'RA1000_Approver_Added',
  EXTERNAL_READ_LOCK_ADDED: 'External_Read_Lock_Added',
  COMPLETED_STATUS_ID: 90,
  workListConfig: { worklistCountBlockSize: 15, countTimerThreshold: 3000 },
  TAKE_CONTROL_CONSTANTS: { delayInSec: 10, defaultTimeout: 20 },
  COUNT: { MINUS_ONE: -1, ZERO: 0, ONE: 1, TWO: 2, THREE: 3, FIVE: 5 },
  TIME: {
    THREE_MINUTES: 180_000,
    MS_FIVE_HUNDRED: 500,
    SS_TWO: 2_000,
    SS_THREE: 3_000,
    SS_FIVE: 5_000,
    SS_TEN: 10_000,
    SS_TWENTY: 20_000,
    SS_THIRTY: 30_000
  },
  APP_ID: {
    WFM: 'WFM',
    NPR: 'NPR',
    PS: 'PS',
    GENERIC: 'Generic',
    UV: 'UV',
    GENESIS: 'GENESIS',
    DA: 'DA',
    SR: 'SmartReport',
    IMPORT: 'import',
    EXPORT: 'export',
    RISI: 'RISi.ContentViewer'
  },
  appURLs: {
    // PLAY URLs
    changePassword: '/user/security/password',
    loginSSO: '/login/sso/token/Universal Viewer',
    login: '/login/Universal Viewer',
    verifyToken: '/verifyToken/Universal Viewer',
    setJWTToken: '/setJWTToken/Universal Viewer',
    helpManual: '/manual/index.html',
    idBrodCast: '/idBroadcast',
    propertyConfigurations: '/property/',
    log: '/api/log/',
    bulklog: '/api/bulklog/',
    desktopIntegration: '/configuration/desktopintegration',
    jwtToken: '/configuration/jwtToken',
    domainInfo: '/configuration/domainInfo',
    xmlTemplates: '/configuration/xmltemplates',
    allConfigurations: '/configuration/allConfigurations',
    keepSessionAlive: '/property/keepSessionAlive',
    logout: '/logout/RadDesktop',
    notification: '/notification/',
    systemProperties: '/systemProperties',
    changePasswordRegx: '/updateRegx',
    passwordExpired: '/passwordexpired/', // NOSONAR
    getUVDateTimePref: '/getUVDateTimePreferences',
    createUVSession: '/createUVSession',
    integrationSecret: '/integrationSessionId',
    wfmCallBackURL: '/WFMHome',
    riscvScanDocCount: '/riscv/scanDocCount',

    // TOMCAT URLs
    users: 'users/',
    radiologists: 'users/radiologists',
    encryptedPassword: '/configuration/user',
    patientAler: '/patientAlert/',
    auditEvent: 'audit/audit-event',
    userPreference: '/user/preference/',
    securityPrivileges: '/security/privileges',
    workListFilter: 'admin/worklist/filter',
    defaultUserWorkList: 'worklists/defaultUserWorklist',
    workItemState: 'workitem-states',
    remoteArchives: 'global-search/datasource',
    worklists: 'worklists',
    defaultWorkListFilters: 'worklists/-1/filters',
    priorities: 'exam/priorities',
    customWorklist: 'user-defined-worklists',
    procedureDescriptions: 'user-defined-worklists/procedure-description',
    procedureDescriptionByIds: 'user-defined-worklists/procedure-id',
    allFolders: 'folders/all',
    searchItemCount: 'search/requested-procedures/item-count',
    searchExams: 'search/requested-procedures',
    searchPatients: 'search/patients',
    cleanupUVSession: '/cleanupUVSession',
    indicators: 'requested-procedures/indicators',
    confidentialPatient: 'patients/markUnMarkConfidentialPatient',
    examTag: 'exam-tag',
    cannedNotes: 'dictionary/canned-note',
    mergePatient: 'patients/mergePatient',

    sharedExam: '/shared-exam'
  },
  configSubCategory: {
    APPLICATION: 'applicationConfiguration',
    AUDIT: 'auditStatus',
    DICOMQR: 'dicomQRConfig',
    SITE: 'siteConfiguration',
    PROPERTIES: 'properties',
    FHIRCAST: 'fhircast',
    EVCONFIG: 'ev',
    DACONFIG: 'da',
    PREFERRED_ARCHIVE: 'preferredArchiveInfo'
  },
  radConfigProperties: [
    'examnotes.enabled',
    'osgi.risic.enabled',
    'protocol.enabled',
    'timeout.takecontrol',
    'auto.ack.timeout.takecontrol',
    'raddesktop.version',
    'session.maxInActivity',
    'worklist.refresh.saveReport',
    'worklist.pageSize',
    'ircc.emr.domain',
    'non.imaging.modalities',
    'sircc.top.count',
    'copyright.year',
    'product.name',
    'fleet.protocoling',
    "fleet.polaris",
    'hostname',
    'dicom.send.status.poll.interval',
    'remote.search.max.results.count',
    'suppress.unknownDataAccessError.notification',
    'examnotes.edit.restriction.enabled'
  ],
  EXCEPTION: {
    1: 'newContent',
    2: 'noOrder',
    4: 'patientMismatch'
  },
  vipExcludedWorkList: ['unsigned', 'assigned', 'to-do', 'attendingread'],
  applicationServerParticipant: {
    ReportingSystem: 'ReportingSystem',
    NPR: 'NativePacsReporting'
  },
  auditActionTypes: {
    Launch: 'Launch',
    Preview: 'Preview',
    ViewImages: 'ViewImages',
    DocContentRetrieval: 'DocContentRetrieval',
    EnableZeroImageDictationWarning: 'EnableZeroImageDictationWarning',
    DisableZeroImageDictationWarning: 'DisableZeroImageDictationWarning',
    Assign: 'ExamAssignmentChangeToAssigned',
    UnAssign: 'ExamAssignmentChangeToUnassigned',
    ScanDocumentsCompleted: 'ScanDocumentsCompleted',
    ScanDocumentsFailure: 'ScanDocumentsFailure',
    ScanDocumentsInitiated: 'ScanDocumentsInitiated',
    TakeControlSuccess: 'TakeControlSuccess',
    TakeControlDenied: 'TakeControlDenied',
    TakeControlRequest: 'TakeControlRequest',
    AcknowledgeException: 'AcknowledgeException',
    NativeAcademicSelectCoReader: 'NativeAcademicWorkflowSelectCoReader',
    NativeAcademicWorkflowReject: 'NativeAcademicWorkflowReject',
    NativeAcademicWorkflowClean: 'NativeAcademicWorkflowClean',
    ReportCreation: 'ReportCreated',
    ReportCreationOnLegacy: 'ReportCreatedOnLegacy',
    ReportUpdation: 'ReportUpdated',
    ReportSave: 'ReportSaved',
    ReportDeletion: 'ReportDeleted',
    ReportDiscard: 'ReportDiscarded',
    AllReporstDiscard: 'AllReportsDiscarded',
    ReportUpdationFailure: 'ReportUpdationFailure',
    ReportCreationFailure: 'ReportCreationFailure',
    ReportCreationOnLegacyFailure: 'ReportCreationOnLegacyFailure',
    ReportSaveFailure: 'ReportSaveFailure',
    ReportDeletionFailure: 'ReportDeletionFailure',
    AllReportsDiscardFailure: 'AllReportsDiscardFailure',
    ReportEmergencyDiscard: 'ReportEmergencyDiscarded',
    ReportEmergencyDiscardFailure: 'ReportEmergencyDiscardFailure',
    AllReportsSaved: 'AllReportsSaved',
    AllReportSaveFailure: 'AllReportSaveFailure',
    AddendumDeletion: 'AddendumDeleted',
    AddendumDeletionFailure: 'AddendumDeletionFailure',
    HyperlinkCreated: 'HyperlinkCreated',
    DaStudySelectSuccess: 'DAStudySelectSuccess',
    DaStudySelectFailure: 'DAStudySelectFailure',
    DaHomeOpen: 'DAHomeOpen',
    DaHomeOpenFailure: 'DAHomeOpenFailure',
    DaHomeOpenReceived: 'DAHomeOpenReceived',
    DaUserLogout: 'DAUserLogout',
    DaSyncSuccess: 'DASyncSuccess',
    DaSyncError: 'DASyncError'
  },
  auditActionCodes: {
    Read: 'Read',
    Execute: 'Execute',
    Update: 'Update',
    Create: 'Create',
    Delete: 'Delete'
  },
  auditEventOutcome: {
    Success: 'Success',
    MinorFailure: 'Minor_Failure',
    SeriousFailure: 'Serious_Failure',
    MajorFailure: 'Major_Failure'
  },
  examStatusByStatusIdMap: {
    0: 'status.Unknown',
    10: 'status.Cancelled',
    20: 'status.Ordered',
    30: 'status.Scheduled',
    40: 'status.Arrived',
    50: 'status.Verified',
    55: 'status.ReadOffline',
    60: 'status.Dictated',
    70: 'status.Transcribed',
    90: 'status.Completed',
    100: 'status.ReferenceOnly'
  },
  objectMappings: [
    { bodyPart: 'procedureBodySite', workItem: true },
    { id: 'requestedProcedureId', workItem: true },
    { managingOrganizationType: 'managingOrganizationType', workItem: true },
    { reasonForExam: 'orderReason', workItem: true },
    { statusId: 'procedureStatusId', workItem: true },

    //the below mappings are not formal properties used by the object, only values set dynamically on the instance for
    // the purpose of output
    { orderOrderer: 'orderOrderer', workItem: true },
    { patientId: 'patientId', workItem: true },
    { procedureEndTime: 'procedureEndTime', workItem: true },
    { protocolWorklist: 'protocolWorklist', workItem: false },
    { examTagDetails: 'examTagDetails', workItem: true },
    { repositoryType: 'repositoryType', workItem: true },
    { repositoryName: 'repositoryName', workItem: true },
    { repositoryId: 'repositoryId', workItem: true },
    // Field that are configurable
    // old attributes
    { accession: 'procedureAccessionNo', workItem: true },
    { imageCount: 'imageCount', workItem: true },
    { indication: 'procedureIndication', workItem: true },
    { managingOrganizationId: 'managingOrganizationId', workItem: true },
    { instituteId: 'managingInstituteId', workItem: true },
    { site: 'site', workItem: true },
    { modality: 'procedureModality', workItem: true },
    { orderingLocation: 'orderingLocation', workItem: true },
    { patientAge: 'patientAge', workItem: true },
    { patientDoB: 'patientBirthDate', workItem: true },
    { patientIdentifier: 'patientIdentifier', workItem: true },
    { patientName: 'patientName', workItem: true },
    { patientVipCode: 'patientVipCode', workItem: true },
    { priority: 'procedurePriority', workItem: false },
    { priorityId: 'procedurePriorityCode', workItem: false },
    { priorityColor: 'priorityBadgeColor', workItem: false },
    { procedureText: 'procedureText', workItem: true },
    { protocolStat: 'protocolStat', workItem: true },
    { procedureCode: 'procedureCode', workItem: true },
    { referringPhysician: 'procedureReferringPhysician', workItem: true },
    { rejectedImageCount: 'rejectedImageCount', workItem: true },
    { status: 'procedureStatus', workItem: true },
    { studyDataAvailability: 'studyDataAvailability', workItem: true },
    { timeOfExam: 'procedureStartTime', workItem: true },
    { verifiedTimeOfExam: 'verifiedTimeOfExam', workItem: true },
    { currentLocation: 'currentLocation', workItem: true }, //exist
    { encounterClass: 'encounterClass', workItem: true }, //exist
    { displayPatientNameHeader: 'displayPatientNameHeader', workItem: true },
    { displayPatientHasMoreExams: 'displayPatientHasMoreExams', workItem: true },
    { archiveAdoptedStatus: 'archiveAdoptedStatus', workItem: true },
    { reportId: 'reportId', workItem: true },
    { reportStatusId: 'reportStatusId', workItem: true },
    { authorId: 'reportAuthorId', workItem: true },
    { lastAuthorId: 'reportLastAuthorId', workItem: true },
    { bodyRegion: 'procedureBodySite', workItem: true },
    { exceptions: 'exceptions', workItem: true },
    { aeTitle: 'aeTitle', workItem: true },
    { equipmentAeTitle: 'equipmentAeTitle', workItem: true },
    { savedExamId: 'descriptorId', workItem: true },
    { savedExamText: 'wiDescription', workItem: true },
    { nextApproverId: 'nextApproverId', workItem: true }
  ],
  comparisonObjectMappings: [
    { bodyPart: 'bodyPart', workItem: true },
    { id: 'requestedProcedureId', workItem: true },
    { managingOrganizationType: 'managingOrganizationType', workItem: true },
    { reasonForExam: 'orderReason', workItem: true },
    { statusId: 'statusId', workItem: true },
    { orderOrderer: 'orderOrderer', workItem: true },
    { patientId: 'patientId', workItem: true },
    { procedureEndTime: 'procedureEndTime', workItem: true },
    { protocolWorklist: 'protocolWorklist', workItem: false },
    { examTagDetails: 'examTagDetails', workItem: true },
    { repositoryType: 'repositoryType', workItem: true },
    { repositoryName: 'siteName', workItem: true },
    { accession: 'accessionNo', workItem: true },
    { imageCount: 'imageCount', workItem: true },
    { indication: 'indication', workItem: true },
    { managingOrganizationId: 'managingOrganizationId', workItem: true },
    { instituteId: 'managingInstituteId', workItem: true },
    { site: 'bodySite', workItem: true },
    { modality: 'modality', workItem: true },
    { orderingLocation: 'orderingLocation', workItem: true },
    { patientDoB: 'birthDate', workItem: true },
    { patientIdentifier: 'patientIdentifier', workItem: true },
    { patientName: 'patientName', workItem: true },
    { patientVipCode: 'patientVipCode', workItem: true },
    { priority: 'priority', workItem: true },
    { priorityId: 'priorityId', workItem: true },
    { priorityColor: 'priorityColor', workItem: true },
    { procedureText: 'procedureText', workItem: true },
    { protocolStat: 'protocolStat', workItem: true },
    { procedureCode: 'procedureCode', workItem: true },
    { referringPhysician: 'referringPhysician', workItem: true },
    { rejectedImageCount: 'rejectedImageCount', workItem: true },
    { status: 'status', workItem: true },
    { studyDataAvailability: 'studyDataAvailability', workItem: true },
    { studyLevelStudyInstanceUID: 'studyLevelStudyInstanceUID', workItem: true },
    { timeOfExam: 'studyTime', workItem: true },
    { currentLocation: 'currentLocation', workItem: true },
    { encounterClass: 'encounterClass', workItem: true },
    { displayPatientNameHeader: 'displayPatientNameHeader', workItem: true },
    { displayPatientHasMoreExams: 'displayPatientHasMoreExams', workItem: true },
    { archiveAdoptedStatus: 'archiveAdoptedStatus', workItem: true },
    { reportId: 'reportId', workItem: true },
    { reportStatusId: 'reportStatusId', workItem: true },
    { authorId: 'reportAuthorId', workItem: true },
    { lastAuthorId: 'reportLastAuthorId', workItem: true }
  ],
  configurableObjectMappings: [
    // New attributes
    { encounterLastMenstruationDate: 'encounterLastMenstruationDate', workItem: true },
    { encounterLocationStartTime: 'encounterLocationStartTime', workItem: true },
    { encounterMedicalConditionsText: 'encounterMedicalConditionsText', workItem: true },
    { encounterPregnancyStatus: 'encounterPregnancyStatus', workItem: true },
    { equipment: 'equipmentName', workItem: true },
    { equipmentTitle: 'equipmentName', workItem: true },
    { procedureSpecialty: 'procedureSpecialty', workItem: true }, //exists
    { initialAuthor: 'reportAuthorId', workItem: true },
    { lastAuthor: 'reportLastAuthorId', workItem: true },
    { organizationName: 'organizationName', workItem: true },
    { patientAddressHome: 'patientAddressHome', workItem: true },
    { patientGender: 'patientGender', workItem: true }, //exists
    { patientPatientUID: 'patientPatientUID', workItem: true },
    { patientPhoneHome: 'patientPhoneHome', workItem: true },
    { patientPhoneWork: 'patientPhoneWork', workItem: true },
    { procedureAcquisitionStatus: 'procedureAcquisitionStatus', workItem: true },
    { procedureAcquisitionTime: 'procedureAcquisitionTime', workItem: true },
    { procedureImprText: 'procedureImprText', workItem: true },
    { procedureKinCount: 'procedureKinCount', workItem: true },
    { instituteName: 'instituteName', workItem: true },
    { site: 'site', workItem: true },
    { procedureOrderNbr: 'procedureOrderNbr', workItem: true },
    { procedurePsCount: 'procedurePsCount', workItem: true },
    { procedureRequestedProcedureUID: 'procedureRequestedProcedureUID', workItem: true },
    { procedureScheduledTime: 'procedureScheduledTime', workItem: true },
    { procedureSearchAcquisitionTime: 'procedureSearchAcquisitionTime', workItem: true },
    { procedureStudyInstanceUID: 'procedureStudyInstanceUID', workItem: true },
    { responsibleAuthor: 'reportApproverId', workItem: true },
    { patientAge: 'patientAge', workItem: true },
    { examId: 'requestedProcedureId', workItem: true },
    { orderingLocationId: 'orderingLocationId', workItem: true },
    { rejectableFlag: 'rejectable', workItem: true },
    { aiFinding: 'aiFinding', workItem: true },
    { aiStatus: 'aiStatus', workItem: true }
  ],
  ExamStatus: {
    ARRIVED: 40,
    DICTATED: 60,
    VERIFIED: 50,
    TRANSCRIBED: 70,
    COMPLETED: 90,
    REFERENCE_ONLY: 100,
    SCHEDULED: 30,
    ORDERED: 20,
    CANCELLED: 10,
    UNKNOWN: 0
  },
  ExamStatusIdMapping: {
    40: 'Arrived',
    60: 'Dictated',
    50: 'Verified',
    70: 'Transcribed',
    90: 'Completed',
    100: 'Reference Only',
    30: 'Scheduled',
    20: 'Ordered',
    10: 'Cancelled',
    0: 'Unknown'
  },
  UserPrivilege: {
    ID_REFERENCEONLY: 'ID_ReferenceOnly',
    COMPLETE: 'Complete',
    TRANSCRIBE: 'Transcribe',
    DICTATE: 'Dictate',
    VERIFY: 'Verify',
    UNVERIFY: 'Unverify',
    ID_ASSIGNMENT: 'ID_Assignment',
    ID_BULKEXAMSTATUSUPDATE: 'ID_BulkExamStatusUpdate',
    ID_MANUALAI: 'ID_ManualAI',
    UVIEWADMGROUP4: 'uViewAdmGroup4',
    STUDY_IMPORT: 'StudyImport',
    ID_CREATECUSTOMWORKLIST: 'ID_CreateCustomWorklist',
    ID_CREATELINKEDWORKLIST: 'ID_CreateLinkedWorklist',
    VIEWCONFIDENTIALPATIENT: 'ViewConfidentialPatient',
    MARKUNMARKCONFIDENTIALPATIENT: 'MarkUnMarkConfidentialPatient',
    ID_RADDESKTOPSYS: 'ID_RadDesktopSys',
    AD_ID_Access: 'AD_ID_Access',
    ID_SIGNREPORT: 'ID_DigSignReport'
  },
  genExCodes: {
    ERR_NOT_IMPLEMENTED: 'ERR_NOT_IMPLEMENTED',
    FOUND_NONE: 'ERR_INVALID_STUDY_IDENTIFIER',
    FOUND_MORE: 'ERR_DUPLICATE_STUDY_IDENTIFIER',
    ERR_CANNOT_OPEN_MORE_TABS: 'ERR_CANNOT_OPEN_MORE_TABS',
    ERR_SYSTEM_ERROR: 'ERR_SYSTEM_ERROR',
    ERR_STUDY_NOT_FOUND: 'ERR_STUDY_NOT_FOUND',
    ERR_ZERO_IMAGE_STUDY: 'ERR_ZERO_IMAGE_STUDY',
    ERR_STUDY_NOT_ONLINE: 'ERR_STUDY_NOT_ONLINE',
    ERR_STUDY_BEING_RETRIEVED_ONLINE: 'ERR_STUDY_BEING_RETRIEVED_ONLINE'
  },
  appLauncher: {
    CEM_IP: 'cem.ip',
    CEM_CONTEXT_PATH: '/psem/servlet/psem.PSEM',
    HTTPS_COLON_2_FWD_SLASHES: 'https://',
    BLANK: '_blank',
    WINDOW_CONFIG: 'width=200,height= 300,menubar=yes,resizable=yes,scrollbars=yes,toolbar=yes'
  },
  genExActionTypes: {
    DEFAULT: '-1',
    OPEN: '0',
    CLOSE_CURRENT: '1',
    CLOSE_ALL: '2',
    HIDE: '3',
    SHOW: '4',
    CLOSE_KEEP_ASSIGNMENT: '5',
    CLOSE_DISCARD_ASSIGNMENT: '6',
    CLOSE: '7'
  },
  XE_SEARCH_RESPONSE_CODES: {
    XE_SUCCESS: 'XER_SERVICE_SUCCESS',
    XE_PARTIAL_SUCCESS: 'XER_SERVICE_PARTIAL_SUCCESS',
    XE_WAITING_FOR_DATA: 'XER_SERVICE_WAITING_FOR_DATA',
    XE_FAILURE: 'XER_SERVICE_FAILURE',
    XE_PROVIDER_PARTIAL_SUCCESS: 'XER_STUDY_SEARCH_PARTIAL_SUCCESS',
    XE_SITE_TYPE_LOCAL: 'Local',
    MAX_RESULTS: 500,
    XE_REMOTE_NODE_ERROR: 'XER_REMOTE_NODE_ERROR',
    XE_PROVIDER_ERROR: 'XER_XED_PROVIDER_ERROR',
    XER_WAITING_FOR_DATA: 'XER_WAITING_FOR_DATA',
    XER_CONNECTION_ERROR_WITH_GWL_SERVER: 'Connection error with GWL Server'
  },
  CRITERIA_HISTORY_GROUP_MAPPING: {
    Search: 'SearchCriteria',
    InlineFilter: 'InlineFilterCriteria'
  },
  EXCLUDE_ZERO_IMAGE: {
    key: 'excludeZeroImageExams',
    value: true,
    mapsTo: 'Zero Image Exams'
  },
  ORDER_BY: {
    key: 'orderBy',
    value: true,
    mapsTo: 'Order By'
  },
  SORT_BY: {
    key: 'sort',
    Priority: 'priority',
    VerifiedDateTime: 'verifiedTimeOfExam',
    StudyDateTime: 'timeOfExam',
    descendingOrder: 'DESC'
  },
  CUSTOM_WORKLIST_TO_ADVANCED_SEARCH_MAP: {
    worklistId: { ignore: true },
    worklistName: { mapsTo: 'Worklist Name', type: 'text' },
    statsOnTop: { ignore: true, type: 'int', convertValuesTo: 'boolean', default: true },
    viewerPreferences: { ignore: true, type: 'int', convertValuesTo: 'boolean', default: true },
    modalityList: { mapsTo: 'Modality', type: 'list', listItemKeyName: 'name' },
    initialInterpreterList: {
      mapsTo: 'Initial Author',
      type: 'list',
      listItemKeyName: 'id',
      convertValuesTo: 'int'
    },
    designatedAuthorList: {
      mapsTo: 'Designated Author',
      type: 'list',
      listItemKeyName: 'id',
      convertValuesTo: 'int'
    },
    radiologistList: { mapsTo: 'Responsible Author', type: 'list', listItemKeyName: 'id', convertValuesTo: 'int' },
    instituteList: { mapsTo: 'Institute', type: 'list', listItemKeyName: 'instituteId', convertValuesTo: 'int' },
    examSpecialtyList: { mapsTo: 'Exam Specialty', type: 'list', listItemKeyName: 'name' },
    orderingLocationList: {
      mapsTo: 'Ordering Location',
      type: 'list',
      listItemKeyName: 'id',
      convertValuesTo: 'string'
    },
    orderingLocationDtoList: { ignore: true },
    assignedToList: { ignore: true },
    patientLocationList: { mapsTo: 'Patient Location', type: 'list', listItemKeyName: 'id', convertValuesTo: 'string' },
    examStatusList: {
      mapsTo: 'Exam Status',
      type: 'list',
      listItemKeyName: 'examStatusNumber',
      convertValuesTo: 'int'
    },
    protocolStatusList: {
      mapsTo: 'Protocol Status',
      type: 'list',
      listItemKeyName: 'protocolStatusNumber',
      convertValuesTo: 'int'
    },
    procedureDescriptionList: {
      mapsTo: 'Exam Description',
      type: 'list',
      listItemKeyName: 'id',
      convertValuesTo: 'string'
    },
    bodyPartList: { mapsTo: 'Body Part', type: 'list', listItemKeyName: 'name' },
    departmentList: { mapsTo: 'Department', type: 'list', listItemKeyName: 'id', convertValuesTo: 'string' },
    examDateRangeToken: { ignore: true },
    beginExamDateRange: { ignore: true },
    endExamDateRange: { ignore: true },
    verifiedDateRangeToken: { ignore: true },
    verifiedBeginDate: { ignore: true },
    verifiedEndDate: { ignore: true },
    orderNumber: { mapsTo: 'Order Number', type: 'text', convertValuesTo: 'string' },
    reportStatusList: {
      mapsTo: 'Report Status',
      type: 'list',
      listItemKeyName: 'reportStatusId',
      convertValuesTo: 'int'
    },
    equipmentList: { mapsTo: 'Modality Station Name', type: 'list', listItemKeyName: 'id' },
    siteList: { mapsTo: 'Site', type: 'list', listItemKeyName: 'name' },
    departmentCkey: { mapsTo: 'Department C-Key', type: 'text', convertValuesTo: 'string' },
    filterJson: { ignore: true },
    filterParamsList: { ignore: true },
    parentWorkListId: { ignore: true },
    isLinked: { ignore: true },
    orderingLocationCkey: { mapsTo: 'Ordering Location C-Key', type: 'text', convertValuesTo: 'string' },
    aifindingList: { mapsTo: 'Findings', type: 'list', listItemKeyName: 'id' },
    excludeZeroImageExams: { mapsTo: 'Zero Image Exams', type: 'radio' },
    examPriorityList: { mapsTo: 'Priority', type: 'list', listItemKeyName: 'id', convertValuesTo: 'int' },
    orderBy: { mapsTo: 'Order By', type: 'radio' },
    exceptions: { mapsTo: 'Exceptions', type: 'list', listItemKeyName: 'id', convertValuesTo: 'int' }
  },
  CUSTOM_WORKLIST_KEYS: {
    'Worklist Name': { key: 'worklistName', field: 'value' },
    'Order Number': { key: 'orderNumber', field: 'value' },
    Modality: { key: 'modalityList', field: 'name' },
    'Patient Location': { key: 'patientLocationList', field: 'id' },
    'Ordering Location': { key: 'orderingLocationList', field: 'id' },
    dateToken: 'examDateRangeToken',
    beginDate: 'beginExamDateRange',
    endDate: 'endExamDateRange',
    verifiedDateRangeToken: 'verifiedDateRangeToken',
    verifiedBeginDate: 'verifiedBeginDate',
    verifiedEndDate: 'verifiedEndDate',
    'Initial Author': { key: 'initialInterpreterList', field: 'id' },
    'Responsible Author': { key: 'radiologistList', field: 'id' },
    'Designated Author': { key: 'designatedAuthorList', field: 'id' },
    Institute: { key: 'instituteList', field: 'instituteId' },
    'Body Part': { key: 'bodyPartList', field: 'name' },
    Department: { key: 'departmentList', field: 'id' },
    'Exam Specialty': { key: 'examSpecialtyList', field: 'name' },
    'Protocol Status': { key: 'protocolStatusList', field: 'protocolStatusNumber' },
    'Exam Status': { key: 'examStatusList', field: 'examStatusNumber' },
    'Exam Description': { key: 'procedureDescriptionList', field: 'id' },
    'Report Status': { key: 'reportStatusList', field: 'reportStatusId' },
    'Department C-Key': { key: 'departmentCkey', field: 'value' },
    'Ordering Location C-Key': { key: 'orderingLocationCkey', field: 'value' },
    Site: { key: 'siteList', field: 'name' },
    'Modality Station Name': { key: 'equipmentList', field: 'id' },
    Findings: { key: 'aifindingList', field: 'id' },
    Priority: { key: 'examPriorityList', field: 'id' },
    'Zero Image Exams': { key: 'excludeZeroImageExams', field: 'value' },
    'Order By': { key: 'orderBy', field: 'value' },
    Exceptions: { key: 'exceptions', field: 'id' }
  },
  ADVANCED_SEARCH_KEYS: {
    MRN: { key: 'mrn', field: 'value' },
    'NHI No.': { key: 'mrn', field: 'value' },
    'Accession Number': { key: 'accession', field: 'value' },
    'Patient Name': { key: 'patientName', field: 'value' },
    'Order Number': { key: 'orderNumber', field: 'value' },
    dateToken: 'dateToken',
    beginDate: 'beginDate',
    endDate: 'endDate',
    verifiedDateRangeToken: 'verifiedDateRangeToken',
    verifiedBeginDate: 'verifiedBeginDate',
    verifiedEndDate: 'verifiedEndDate',
    patientBirthDateToken: 'patientBirthDateToken',
    patientBirthBeginDate: 'patientBirthBeginDate',
    patientBirthEndDate: 'patientBirthEndDate',
    Modality: { key: 'modality', field: 'name' },
    'Patient Location': { key: 'currentLocation', field: 'name' },
    'Ordering Location': { key: 'orderingLocation', field: 'id' },
    'Initial Author': { key: 'initialInterpreters', field: 'id' },
    'Responsible Author': { key: 'radiologists', field: 'id' },
    'Designated Author': { key: 'designatedAuthor', field: 'id' },
    Institute: { key: 'instituteList', field: 'instituteId' },
    'Body Part': { key: 'bodyParts', field: 'name' },
    Department: { key: 'departmentIds', field: 'id' },
    'Exam Specialty': { key: 'specialties', field: 'name' },
    'Exam Status': { key: 'examStatusIds', field: 'examStatusNumber' },
    'Exam Description': { key: 'descriptions', field: 'id' },
    'Report Status': { key: 'reportStatusIds', field: 'reportStatusId' },
    'Department C-Key': { key: 'departmentIds', field: 'value' },
    'Ordering Location C-Key': { key: 'orderingLocationId', field: 'value' },
    Site: { key: 'site', field: 'name' },
    'Modality Station Name': { key: 'equipment', field: 'id' },
    Findings: { key: 'aiFinding', field: 'id' },
    Priority: { key: 'priority', field: 'id' },
    'Zero Image Exams': { key: 'excludeZeroImageExams', field: 'value' },
    'Order By': { key: 'orderBy', field: 'value' },
    Exceptions: { key: 'exceptions', field: 'id' }
  },
  ADVANCED_SEARCH_FILTER_KEYS: {
    MRN: { key: 'mrn', field: 'value' },
    'NHI No.': { key: 'mrn', field: 'value' },
    'Accession Number': { key: 'accession', field: 'value' },
    'Patient Name': { key: 'patientName', field: 'value' },
    'Order Number': { key: 'orderNumber', field: 'value' },
    'Time of Exam': 'timeOfExam',
    beginDate: 'beginDate',
    endDate: 'endDate',
    patientBirthDateToken: 'patientBirthDateToken',
    patientBirthBeginDate: 'patientBirthBeginDate',
    patientBirthEndDate: 'patientBirthEndDate',
    Modality: { key: 'modality', field: 'name' },
    'Patient Location': { key: 'currentLocation', field: 'name' },
    'Ordering Location': { key: 'orderingLocation', field: 'id' },
    'Initial Author': { key: 'initialInterpreters', field: 'id' },
    'Responsible Author': { key: 'radiologists', field: 'id' },
    'Designated Author': { key: 'designatedAuthor', field: 'id' },
    Institute: { key: 'instituteName', field: 'name' },
    'Body Part': { key: 'bodyParts', field: 'name' },
    Department: { key: 'departments', field: 'name' },
    'Exam Specialty': { key: 'specialties', field: 'name' },
    'Exam Status': { key: 'status', field: 'name' },
    'Exam Description': { key: 'descriptions', field: 'id' },
    'Report Status': { key: 'reportStatus', field: 'name' },
    'Department C-Key': { key: 'departmentIds', field: 'value' },
    'Ordering Location C-Key': { key: 'orderingLocationId', field: 'value' },
    Site: { key: 'sites', field: 'name' },
    'Modality Station Name': { key: 'equipments', field: 'name' },
    Findings: { key: 'aiFinding', field: 'id' },
    Priority: { key: 'priority', field: 'id' },
    'Zero Image Exams': { key: 'excludeZeroImageExams', field: 'value' },
    'Order By': { key: 'orderBy', field: 'value' },
    Exceptions: { key: 'exceptions', field: 'id' }
  },
  reportActionTypes: {
    Start: 'START',
    Login: 'LOGIN',
    OpenReport: 'OPENREPORT',
    SaveReport: 'SAVEREPORT',
    CancelReport: 'CANCELREPORT',
    ForceMinimize: 'FORCEMINIMIZE',
    Minimize: 'MINIMIZE',
    Logout: 'LOGOUT',
    Terminate: 'TERMINATE',
    PreviewReport: 'PREVIEWREPORT',
    SaveOnCloseReport: 'SAVEONCLOSEREPORT',
    Save: 'SAVE',
    Cancel: 'CANCEL',
    CurrentContext: 'CURRENTCONTEXT',
    SETASSOCIATION: 'SETASSOCIATION'
  },
  dictationIntegrationStatus: {
    None: '0',
    LaunchApplicationInitiated: '1',
    Enabled: '2',
    Disabled: '3',
    TimedOut: '4'
  },
  ReportStatus: {
    Discarded: '-1',
    Pending: '0',
    WetRead: '1',
    Draft: '2',
    PendingCorrection: '3',
    Corrected: '4',
    CorrectionRejected: '5',
    PendingSignature: '6',
    SignatureRejected: '7',
    Final: '8',
    Signed: '9'
  },
  SEARCH_CONSTANTS: {
    PATIENT_GROUPS_LIMIT: 249,
    MAX_LIMIT: 500,
    LOCAL_REPOSITORY: 'Local',
    REMOTE_EXAM_SEARCH_TYPE: 'RemoteExamSearch',
    ACCESSION_SEARCH_TYPE: 'Accession Number',
    PATIENT_NAME_SEARCH_TYPE: 'Patient Name',
    MRN_SEARCH_TYPE: 'MRN / Patient ID'
  },
  WFMReportStatuses: {
    '-1': -2, // Discard
    1: 7200, // WetRead
    2: 7500, // Draft
    3: 7800, // PendingCorrection
    4: 8100, // Corrected
    5: 8400, // CorrectionRejected
    6: 7000, // PendingSignature
    7: 8700, // SignatureRejected
    8: 9000, // Final,
    9: 10000 // Signed
  },
  WFMAddendumReportStatuses: {
    '-1': -3, // Discard
    2: 9500, // Draft
    3: 9800, // PendingCorrection
    4: 9100, // Corrected
    5: 9400, // CorrectionRejected
    6: 9900, // PendingSignature
    7: 9700, // SignatureRejected
    8: 9000, // Final
    9: 10000 // Signed
  },
  AddendumStatus: {
    Yes: '-1',
    No: '0'
  },
  pluginLoadStatus: {
    None: '0',
    LoadPluginInitiated: '1',
    PluginLoaded: '2',
    PluginLoadFailed: '3'
  },
  windowState: {
    Hide: 'HIDE',
    Minimize: 'MINIMIZE',
    ShowOnTop: 'SHOW_ON_TOP',
    NoStateChange: 'NO_STATE_CHANGE'
  },
  reportingAppName: {
    NPR: 'NativeReporting',
    PS: 'PowerScribe',
    Generic: 'GenericPlugin',
    None: 'None'
  },
  reportReOpenParams: {
    source: 'desktop-integration',
    reason: 'reopen'
  },
  DO_NOT_ALLOW: 'doNotAllow',
  BREAK_TAG: '<br><br>',
  MAX_TAB_ERROR: 'MAX_TAB_ERROR',
  PENDING_RESPONSE: 'PENDING_RESPONSE',
  FOUND_MORE: 'FOUND_MORE',
  FOUND_NONE: 'FOUND_NONE',
  WORKITEM_STATE: 'WORKITEM_STATE',
  WORKITEM_CREATE: 'WORKITEM_CREATE',
  SEARCH_ERROR: 'SEARCH_ERROR',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  FAILED: 'FAILED',
  dataServiceTimeout: 10000,
  externalTabId: '**externalTab**',
  messageDelimiter: '|',
  dateRangeTokenMap: {
    last24hours: 'H-24',
    last48hours: 'H-48',
    last72hours: 'H-72',
    yesterday: 'T-1',
    today: 'T-0',
    last2days: 'T-2',
    last3days: 'T-3',
    last7days: 'T-7',
    last30days: 'T-30',
    last365days: 'T-365',
    allDates: 'All'
  },
  datePickerRangeValues: [
    'All',
    'T-0',
    'T-1',
    'T-2',
    'T-3',
    'T-7',
    'T-30',
    'T-365',
    'H-24',
    'H-48',
    'H-72',
    'T+1',
    'T+2',
    'T+3',
    'T+7',
    'T+30'
  ],
  repositoryType: {
    LOCAL: 'Local',
    REMOTE: 'REMOTE',
    XE: 'XE',
    XED: 'XED',
    GLOBAL: 'GWL'
  },
  archiveAdoptionStatus: {
    ArchiveAdopted: 'YES',
    NO: 'NO',
    InProgress: 'INPROGRESS',
    Error: 'FAILED'
  },
  studyDataAvailability: {
    UNAVAILABLE: 'UNAVAILABLE',
    OFFLINE: 'OFFLINE',
    ONLINE: 'ONLINE',
    CENTERA: 'CENTERA',
    THIRD_PARTY: '3RDParty',
    ERROR: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    NEARLINE: 'NEARLINE'
  },
  systemWorkListDescription: [
    {
      id: 'assigned',
      displayOrder: 1,
      displayName: 'assigned',
      description: 'Reserved or locked Exams ordered by priority and study_dttm'
    },
    {
      id: 'unsigned',
      displayOrder: 2,
      displayName: 'unsigned',
      description: 'Exams with dictated and transcribed ordered by priority and study_dttm'
    },
    {
      id: 'attendingread',
      displayOrder: 3,
      displayName: 'attendingRead',
      description: 'Exams with transcribed status ordered by priority and study_dttm'
    },
    {
      id: 'recently-viewed',
      displayOrder: 4,
      displayName: 'recentExams.recentExamsLabel',
      description: 'Recent Exams ordered by launched_dttm'
    },
    {
      id: 'tabWorklist',
      displayOrder: 5,
      displayName: 'tabWorklist',
      description: 'Open Tab Exams ordered by preview_dttm'
    },
    {
      id: 'exceptionWorklist',
      displayOrder: 6,
      displayName: 'exceptionWorklist',
      description: 'Exams with dirty flags ordered by study_dttm'
    },
    {
      id: 'nawCoreport',
      displayOrder: 7,
      displayName: 'naw.coreport',
      description: 'Exams with Prelim status and having coreporter assigned'
    },
    {
      id: 'nawReviewRequested',
      displayOrder: 8,
      displayName: 'naw.reviewRequested',
      description: 'Exams with Draft status and was rejected to someone'
    },
    {
      id: 'globalWorklist',
      displayOrder: 9,
      displayName: 'global',
      description: 'Global Exams with verified, dictated and transcribed status ordered by priority and study_dttm'
    }
  ],
  system_properties: {
    SYSTEM_DEFAULT_LANGUAGE: 'default_language',
    DISABLE_MULTIPLE_LOGIN: 'disable.multiple.login',
    UPDATE_PASSWORD_FEATURE: 'updatePasswordFeature',
    SESSION_MAXINACTIVITY: 'session.maxInActivity',
    APP_BASE_URL: 'application.service.base.url',
    SUPPORTED_LANGUAGES: 'play.i18n.langs',
    NOT_FOR_DIAGNOSTIC_USE_MESSAGE_ENABLED: 'product.notForDiagnosticUseMessage.enabled'
  },
  stateIcons: {
    unlocked: 'ico-unlock-16',
    locked: 'ico-lock-16',
    reading: 'ico-microphone-16',
    monitor: 'ico-monitor-16'
  },
  stateClasses: {
    none: 'assigned-none',
    self: 'assigned-self',
    other: 'assigned-other',
    external: 'assigned-external',
    disabled: 'assigned-disabled'
  },
  MergePatient: {
    PID: 'pid',
    PATIENT_NAME: 'patientName',
    DOB: 'dob',
    Gender: {
      LABEL: 'gender',
      MALE: 'Male',
      FEMALE: 'Female'
    },
    FORM_VALID: 'VALID'
  },
  queryParams: [
    'diDisable',
    'logToServer',
    'logToConsole',
    'logLevel',
    'logPerformance',
    'logInteractions',
    'performanceHooks',
    'enableLineShaft',
    'reportType'
  ],
  CATEGORIES_RESPONSE_CODES: {
    success: 'SUCCESS',
    partial: 'PARTIAL',
    failure: 'FAILURE'
  },
  DateStyle: {
    FULL: 'FULL',
    LONG: 'LONG',
    MEDIUM: 'MEDIUM',
    SHORT: 'SHORT'
  },
  DateFormat: {
    dmy: 'Day Month Year',
    mdy: 'Month Day Year',
    ymd: 'Year Month Day'
  },
  TimeFormat: {
    FORMAT_AMPM: 'AM/PM',
    FORMAT_24H: '24h'
  },
  Standard_DateFormats: {
    MMDDYYYY_WITH_SLASH: 'MM/DD/yyyy',
    YYYYMMDD_WITH_HYPHEN: 'yyyy-MM-DD'
  },
  Standard_TimeFormats: {
    HHMMSSA_WITH_COLON: 'HH:mm:ss A',
    HHMMSS_WITH_COLON: 'HH:mm:ss',
    HHMMA_WITH_COLON: 'HH:mm A',
    HHMM_WITH_COLON: 'HH:mm'
  },
  SEND_IN_DICOM: {
    JOB_INPROGRESS_OR_COMPLETED: 400,
    JOB_PARTIAL_COMPLETED: 406,
    INTERNAL_ERROR: 500
  },
  SEND_IN_DICOM_STATUS: {
    IN_PROGRESS: 'In Progress',
    COMPLETED_OR_FAILED: 'Completed or failed'
  },
  DelimiterSpace: 'space',
  locale: {
    default: 'en-US',
    monthInDigits: ['ko-KR'],
    momentOverride: {
      monthsShort: {
        'de-de': 'Jan_Feb_Mär_Apr_Mai_Jun_Jul_Aug_Sep_Okt_Nov_Dez'.split('_'),
        'nl-be': 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_')
      },
      FirstDayOfWeek: {
        'da-dk': 1,
        'de-de': 1,
        'en-gb': 1,
        'en-us': 0,
        en: 0,
        'es-es': 1,
        'fi-fi': 1,
        'fr-fr': 1,
        'it-it': 1,
        'nb-no': 1,
        'nl-be': 1,
        'pl-pl': 1,
        'pt-br': 0,
        'pt-pt': 0,
        'ru-ru': 1,
        'ru-kz': 1,
        'sv-se': 1,
        'tr-tr': 1,
        'en-gr': 1,
        'en-id': 1,
        'en-hu': 1,
        'en-vn': 0,
        'en-sa': 0,
        'en-il': 0,
        'en-kz': 1,
        'ko-KR': 0
      }
    }
  },
  eventWithOwner: [
    'Assignment Applied',
    'Take Control Request',
    'Take Control Success',
    'Take Control Denied',
    'Co-reader Selected',
    'Report Rejected'
  ],
  advanceSearchLabelMap: {
    worklistName: 'advanceSearch.worklistNameLabel',
    patientName: 'advanceSearch.patientNameLabel',
    accession: 'advanceSearch.accessionNumberLabel',
    nhi: 'advanceSearch.nhiLabel',
    mrn: 'advanceSearch.mrnLabel',
    dob: 'advanceSearch.dobLabel',
    descriptions: 'customWorklist.examDescriptionMsg',
    timeOfExam: 'advanceSearch.timeOfExamLabel',
    verifiedDateTime: 'label.verifiedTimeDate',
    modality: 'advanceSearch.modalityLabel',
    bodyParts: 'advanceSearch.bodyPartLabel',
    departmentIds: 'advanceSearch.departmentLabel',
    departmentId: 'advanceSearch.DepartmentCKeyLabel',
    exceptions: 'advanced.search.exception',
    specialties: 'advanceSearch.examSpecialtyLabel',
    examStatusIds: 'advanceSearch.examStatusLabel',
    aiFinding: 'advanceSearch.findingsLabel',
    initialInterpreters: 'advanceSearch.initialAuthorLabel',
    designatedAuthor: 'workloadManager.listContainer.label.designatedAuthor',
    referringPhysician: 'advanceSearch.referringPhysicianLabel',
    instituteList: 'advanceSearch.instituteLabel',
    equipment: 'advanceSearch.ModalityStationNameLabel',
    orderNumber: 'advanceSearch.orderNumberLabel',
    orderingLocation: 'advanceSearch.orderingLocationLabel',
    orderingLocationId: 'advanceSearch.OrderingLocationCKeyLabel',
    currentLocation: 'advanceSearch.patientLocationLabel',
    priority: 'workloadManager.listContainer.label.priority',
    reportStatusIds: 'advanceSearch.reportStatusLabel',
    radiologists: 'advanceSearch.responsibleAuthorLabel',
    site: 'advanceSearch.SiteLabel'
  },
  TODO_WORKLIST: [
    'assigned',
    'unsigned',
    'attendingRead',
    'tabWorklist',
    'recentExams.recentExamsLabel',
    'RecentlyViewed',
    'AttendingReview',
    'TabWorklist',
    'exceptionWorklist'
  ],
  ADV_SEARCH_DEFAULT_DATE_FORMAT: 'M/D/YYYY',
  searchFilterCharacterLimit: 4000,
  SavedFoldersLabelMap: {
    folders: 'folders',
    items: 'items',
    sharees: 'sharees',
    currentUser: 'current-user',
    sharee: 'sharee',
    folder: 'folder',
    exam: 'exam',
    added: 'added',
    update: 'update',
    removed: 'removed'
  },
  wfmContextPlugin: {
    STATUS: 'STATUS',
    actionTypes: {
      REQUEST_TOKEN: 'RequestToken',
      LAUNCH: 'Launch',
      LOGOUT: 'Logout',
      SET_TOKEN: 'SetToken',
      SET_PATIENT: 'SetPatient'
    },
    topics: {
      WFM_APP: 'WFM_APP',
      WFM_APP_RESPONSE: 'WFM_APP_RESPONSE',
      WFM_API: 'WFM_API',
      WFM_API_RESPONSE: 'WFM_API_RESPONSE'
    },
    statusTypes: {
      SUCCESS: 'Success',
      FAILURE: 'Failure',
      TOKEN_INVALID: 'Token invalid',
      NO_PERMISSION: 'No permission'
    }
  },
  BACKSLASH: '\\',
  ESCAPE_BLACKSLASH: '\\\\',
  REGEX_ALPHA_NUMBERIC_HYPHEN: '^[a-zA-Z]([a-zA-Z0-9-]*[a-zA-Z]{1})?$',
  PLACEHOLDER_USERNAME: '{{USERNAME}}',
  PLACEHOLDER_PASSWORD: '{{PASSWORD}}',

  PRIORITIES: {
    STAT: 'STAT',
    ROUTINE: 'ROUTINE'
  },

  UV_STUDY_MANAGEMENT_INPROGRESS: 6,
  WFM_STUDY_MANAGEMENT_INPROGRESS: 10,

  NHI: 'nhi',

  DEFAULT_LANGUAGE: 'en-US',

  DIGITAL_SIGN_CONFS: {
    signatureEnabledKey: 'digitalSignature.enabled',
    signatureTypeKey: 'digitalSignature.type'
  },

  PACS_VERSION8: 'v8',
  CPACS_CONFIG_KEYS: {
    version: 'cpacsVersion'
  },

  USER_PREFERENCE_KEYS: {
    SR_DEPARTMENT: 'sr-department'
  },

  FHIRCAST_NGI_KEY: 'fhirCastConfig',
  FHIRCAST_DEFAULT_CONFIG: {
    RetryPeriod: 2_000,
    RetryMaxcount: 5,
    ExamRelaunchDelay: 2_000,
    EvLaunchRetryMaxCount: 3,
    EvRequestTimeout: 30_000,
    EvHealthCheckInterval: 10_000,
    WebSocketUseSecureProtocol: true,
    WebSocketProtocolPrefix: 'ngv',
    WebSocketProtocolTokenPrefix: 'auth#',
    MicroappTaskStatusCheckInterval: 10_000,
    ImagingStudyResource: 'DEFALT',
    ImagingStudySource: 'ETP'
  },
  DX_HUB_ACTION: {
    CLOSE: 'CloseDxHub',
    CLEAR: 'ClearDxHub'
  },
  ENABLE_INSTITUTE_SEPARATION: 'enableInstituteSeparation',
  ENABLE_REMOTE_REPOSITORY_ACCESS_CONTROL: 'remoteArchiveAccessCtrl',
  COOKIE_PROP: {
    expires: 1 / 24, // Cookie expires in 1 hour
    path: '/', // Path where the cookie is accessible
    secure: true // Cookie is only sent over HTTPS
  }
};
